<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="FMH"><span class="right_1" epub:type="pagebreak" id="page_7" title="7">Contents</span></p>
<p class="TOC_FMH"><a href="#/xhtml/Acknowledgments"><span class="Italic">Acknowledgments and Author’s Note</span></a></p>
<p class="TOC_FMH"><a href="#/xhtml/Preface"><span class="Italic">Preface: Detroit’s Most Congenial Host</span></a></p>
<p class="TOC_CT1a"><a href="#/xhtml/Chapter01"><span class="Bold">1.</span></a></p>
<p class="TOC_CT"><a href="#/xhtml/Chapter01">Old Hopes, New Dreams</a></p>
<p class="TOC_CT1"><span href="#/xhtml/Chapter02" title="Link target outside of Sample"><span class="Bold">2.</span></span></p>
<p class="TOC_CT"><span href="#/xhtml/Chapter02" title="Link target outside of Sample">Stage Lights and Nightlife</span></p>
<p class="TOC_CT1"><span href="#/xhtml/Chapter03" title="Link target outside of Sample"><span class="Bold">3.</span></span></p>
<p class="TOC_CT"><span href="#/xhtml/Chapter03" title="Link target outside of Sample">Mayor of the Valley</span></p>
<p class="TOC_CT1"><span href="#/xhtml/Chapter04" title="Link target outside of Sample"><span class="Bold">4.</span></span></p>
<p class="TOC_CT"><span href="#/xhtml/Chapter04" title="Link target outside of Sample">The Twenty-Dollar Man</span></p>
<p class="TOC_CT1"><span href="#/xhtml/Chapter05" title="Link target outside of Sample"><span class="Bold">5.</span></span></p>
<p class="TOC_CT"><span href="#/xhtml/Chapter05" title="Link target outside of Sample">Down on Hastings Street</span></p>
<p class="TOC_CT1"><span href="#/xhtml/Chapter06" title="Link target outside of Sample"><span class="Bold">6.</span></span></p>
<p class="TOC_CT"><span href="#/xhtml/Chapter06" title="Link target outside of Sample">Idlewild</span></p>
<p class="TOC_CT1"><span href="#/xhtml/Chapter07" title="Link target outside of Sample"><span class="Bold">7.</span></span></p>
<p class="TOC_CT"><span href="#/xhtml/Chapter07" title="Link target outside of Sample">Every Day Is a New Story</span></p>
<p class="TOC_CT1"><span href="#/xhtml/Chapter08" title="Link target outside of Sample"><span class="Bold">8.</span></span></p>
<p class="TOC_CT"><span href="#/xhtml/Chapter08" title="Link target outside of Sample">Let It Roll!</span></p>
<p class="TOC_CT1"><span href="#/xhtml/Chapter09" title="Link target outside of Sample"><span class="Bold">9.</span></span></p>
<p class="TOC_CT"><span href="#/xhtml/Chapter09" title="Link target outside of Sample">Lucky Old Fella</span></p>
<p class="TOC_BMH"><span href="#/xhtml/Sources" title="Link target outside of Sample"><span class="Italic">Sources</span></span></p>
<p class="TOC_BMH"><span href="#/xhtml/Index" title="Link target outside of Sample"><span class="Italic">Index</span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?86a919c8